/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedUsageRouteImport } from './routes/_authenticated/usage'
import { Route as AuthenticatedSkillsRouteImport } from './routes/_authenticated/skills'
import { Route as AuthenticatedSettingsRouteImport } from './routes/_authenticated/settings'
import { Route as AuthenticatedNewRouteImport } from './routes/_authenticated/new'
import { Route as AuthenticatedLyricsRouteImport } from './routes/_authenticated/lyrics'
import { Route as AuthenticatedJobsRouteImport } from './routes/_authenticated/jobs'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as AuthenticatedSkillsImportRouteImport } from './routes/_authenticated/skills.import'
import { Route as AuthenticatedSkillsNameRouteImport } from './routes/_authenticated/skills.$name'
import { Route as AuthenticatedJobsIdRouteImport } from './routes/_authenticated/jobs.$id'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedUsageRoute = AuthenticatedUsageRouteImport.update({
  id: '/usage',
  path: '/usage',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSkillsRoute = AuthenticatedSkillsRouteImport.update({
  id: '/skills',
  path: '/skills',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSettingsRoute = AuthenticatedSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedNewRoute = AuthenticatedNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedLyricsRoute = AuthenticatedLyricsRouteImport.update({
  id: '/lyrics',
  path: '/lyrics',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedJobsRoute = AuthenticatedJobsRouteImport.update({
  id: '/jobs',
  path: '/jobs',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSkillsImportRoute =
  AuthenticatedSkillsImportRouteImport.update({
    id: '/import',
    path: '/import',
    getParentRoute: () => AuthenticatedSkillsRoute,
  } as any)
const AuthenticatedSkillsNameRoute = AuthenticatedSkillsNameRouteImport.update({
  id: '/$name',
  path: '/$name',
  getParentRoute: () => AuthenticatedSkillsRoute,
} as any)
const AuthenticatedJobsIdRoute = AuthenticatedJobsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AuthenticatedJobsRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/jobs': typeof AuthenticatedJobsRouteWithChildren
  '/lyrics': typeof AuthenticatedLyricsRoute
  '/new': typeof AuthenticatedNewRoute
  '/settings': typeof AuthenticatedSettingsRoute
  '/skills': typeof AuthenticatedSkillsRouteWithChildren
  '/usage': typeof AuthenticatedUsageRoute
  '/jobs/$id': typeof AuthenticatedJobsIdRoute
  '/skills/$name': typeof AuthenticatedSkillsNameRoute
  '/skills/import': typeof AuthenticatedSkillsImportRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/jobs': typeof AuthenticatedJobsRouteWithChildren
  '/lyrics': typeof AuthenticatedLyricsRoute
  '/new': typeof AuthenticatedNewRoute
  '/settings': typeof AuthenticatedSettingsRoute
  '/skills': typeof AuthenticatedSkillsRouteWithChildren
  '/usage': typeof AuthenticatedUsageRoute
  '/jobs/$id': typeof AuthenticatedJobsIdRoute
  '/skills/$name': typeof AuthenticatedSkillsNameRoute
  '/skills/import': typeof AuthenticatedSkillsImportRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/login': typeof LoginRoute
  '/_authenticated/dashboard': typeof AuthenticatedDashboardRoute
  '/_authenticated/jobs': typeof AuthenticatedJobsRouteWithChildren
  '/_authenticated/lyrics': typeof AuthenticatedLyricsRoute
  '/_authenticated/new': typeof AuthenticatedNewRoute
  '/_authenticated/settings': typeof AuthenticatedSettingsRoute
  '/_authenticated/skills': typeof AuthenticatedSkillsRouteWithChildren
  '/_authenticated/usage': typeof AuthenticatedUsageRoute
  '/_authenticated/jobs/$id': typeof AuthenticatedJobsIdRoute
  '/_authenticated/skills/$name': typeof AuthenticatedSkillsNameRoute
  '/_authenticated/skills/import': typeof AuthenticatedSkillsImportRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/dashboard'
    | '/jobs'
    | '/lyrics'
    | '/new'
    | '/settings'
    | '/skills'
    | '/usage'
    | '/jobs/$id'
    | '/skills/$name'
    | '/skills/import'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/dashboard'
    | '/jobs'
    | '/lyrics'
    | '/new'
    | '/settings'
    | '/skills'
    | '/usage'
    | '/jobs/$id'
    | '/skills/$name'
    | '/skills/import'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/login'
    | '/_authenticated/dashboard'
    | '/_authenticated/jobs'
    | '/_authenticated/lyrics'
    | '/_authenticated/new'
    | '/_authenticated/settings'
    | '/_authenticated/skills'
    | '/_authenticated/usage'
    | '/_authenticated/jobs/$id'
    | '/_authenticated/skills/$name'
    | '/_authenticated/skills/import'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/usage': {
      id: '/_authenticated/usage'
      path: '/usage'
      fullPath: '/usage'
      preLoaderRoute: typeof AuthenticatedUsageRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/skills': {
      id: '/_authenticated/skills'
      path: '/skills'
      fullPath: '/skills'
      preLoaderRoute: typeof AuthenticatedSkillsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/new': {
      id: '/_authenticated/new'
      path: '/new'
      fullPath: '/new'
      preLoaderRoute: typeof AuthenticatedNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/lyrics': {
      id: '/_authenticated/lyrics'
      path: '/lyrics'
      fullPath: '/lyrics'
      preLoaderRoute: typeof AuthenticatedLyricsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/jobs': {
      id: '/_authenticated/jobs'
      path: '/jobs'
      fullPath: '/jobs'
      preLoaderRoute: typeof AuthenticatedJobsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/dashboard': {
      id: '/_authenticated/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthenticatedDashboardRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/skills/import': {
      id: '/_authenticated/skills/import'
      path: '/import'
      fullPath: '/skills/import'
      preLoaderRoute: typeof AuthenticatedSkillsImportRouteImport
      parentRoute: typeof AuthenticatedSkillsRoute
    }
    '/_authenticated/skills/$name': {
      id: '/_authenticated/skills/$name'
      path: '/$name'
      fullPath: '/skills/$name'
      preLoaderRoute: typeof AuthenticatedSkillsNameRouteImport
      parentRoute: typeof AuthenticatedSkillsRoute
    }
    '/_authenticated/jobs/$id': {
      id: '/_authenticated/jobs/$id'
      path: '/$id'
      fullPath: '/jobs/$id'
      preLoaderRoute: typeof AuthenticatedJobsIdRouteImport
      parentRoute: typeof AuthenticatedJobsRoute
    }
  }
}

interface AuthenticatedJobsRouteChildren {
  AuthenticatedJobsIdRoute: typeof AuthenticatedJobsIdRoute
}

const AuthenticatedJobsRouteChildren: AuthenticatedJobsRouteChildren = {
  AuthenticatedJobsIdRoute: AuthenticatedJobsIdRoute,
}

const AuthenticatedJobsRouteWithChildren =
  AuthenticatedJobsRoute._addFileChildren(AuthenticatedJobsRouteChildren)

interface AuthenticatedSkillsRouteChildren {
  AuthenticatedSkillsNameRoute: typeof AuthenticatedSkillsNameRoute
  AuthenticatedSkillsImportRoute: typeof AuthenticatedSkillsImportRoute
}

const AuthenticatedSkillsRouteChildren: AuthenticatedSkillsRouteChildren = {
  AuthenticatedSkillsNameRoute: AuthenticatedSkillsNameRoute,
  AuthenticatedSkillsImportRoute: AuthenticatedSkillsImportRoute,
}

const AuthenticatedSkillsRouteWithChildren =
  AuthenticatedSkillsRoute._addFileChildren(AuthenticatedSkillsRouteChildren)

interface AuthenticatedRouteChildren {
  AuthenticatedDashboardRoute: typeof AuthenticatedDashboardRoute
  AuthenticatedJobsRoute: typeof AuthenticatedJobsRouteWithChildren
  AuthenticatedLyricsRoute: typeof AuthenticatedLyricsRoute
  AuthenticatedNewRoute: typeof AuthenticatedNewRoute
  AuthenticatedSettingsRoute: typeof AuthenticatedSettingsRoute
  AuthenticatedSkillsRoute: typeof AuthenticatedSkillsRouteWithChildren
  AuthenticatedUsageRoute: typeof AuthenticatedUsageRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,
  AuthenticatedJobsRoute: AuthenticatedJobsRouteWithChildren,
  AuthenticatedLyricsRoute: AuthenticatedLyricsRoute,
  AuthenticatedNewRoute: AuthenticatedNewRoute,
  AuthenticatedSettingsRoute: AuthenticatedSettingsRoute,
  AuthenticatedSkillsRoute: AuthenticatedSkillsRouteWithChildren,
  AuthenticatedUsageRoute: AuthenticatedUsageRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
